import { render, staticRenderFns } from "./ListarArticulos.vue?vue&type=template&id=60346fcc&"
import script from "./ListarArticulos.vue?vue&type=script&lang=js&"
export * from "./ListarArticulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports